import React from 'react';
import { Bell, BellOff } from 'lucide-react';
import { SectionHeader } from './SectionHeader';

// Notification Status Component
export function NotificationStatus({ notificationStats }) {
  const isEstimated = notificationStats.isEstimated;
  
  return (
    <div className="bg-[hsl(var(--surface))] border border-[hsl(var(--border))] rounded-xl overflow-hidden">
      <SectionHeader icon={Bell} title="Notification Status" subtitle={isEstimated ? "Estimated based on channel patterns" : "Current snapshot from Telegram (not filterable by date)"} />
      
      <div className="p-5">
        {/* Main Stat */}
        <div className="text-center mb-5">
          <div className={`inline-flex items-center justify-center w-24 h-24 rounded-full mb-3 ${
            notificationStats.isGood ? 'bg-[#10B981]/10 border-2 border-[#10B981]/30' :
            notificationStats.isMedium ? 'bg-[#F59E0B]/10 border-2 border-[#F59E0B]/30' :
            'bg-[#E63946]/10 border-2 border-[#E63946]/30'
          }`}>
            <div>
              <p className={`text-2xl font-bold ${
                notificationStats.isGood ? 'text-[#10B981]' :
                notificationStats.isMedium ? 'text-[#F59E0B]' :
                'text-[#E63946]'
              }`}>{notificationStats.rate}%</p>
              <p className="text-[10px] text-[#6B7280]">enabled</p>
            </div>
          </div>
          <p className={`text-sm font-medium ${
            notificationStats.isGood ? 'text-[#10B981]' :
            notificationStats.isMedium ? 'text-[#F59E0B]' :
            'text-[#E63946]'
          }`}>
            {notificationStats.isGood ? 'Excellent!' : notificationStats.isMedium ? 'Average' : 'Needs Improvement'}
          </p>
        </div>
        
        {/* Breakdown */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="bg-[#10B981]/10 rounded-lg p-3 text-center border border-[#10B981]/20">
            <Bell size={16} className="mx-auto mb-1 text-[#10B981]" />
            <p className="text-lg font-bold text-[#10B981]">{notificationStats.enabled.toLocaleString()}</p>
            <p className="text-[10px] text-[#6B7280]">Notifications ON</p>
          </div>
          <div className="bg-[#6B7280]/10 rounded-lg p-3 text-center border border-[#6B7280]/20">
            <BellOff size={16} className="mx-auto mb-1 text-[#6B7280]" />
            <p className="text-lg font-bold text-[#6B7280]">{notificationStats.disabled.toLocaleString()}</p>
            <p className="text-[10px] text-[#6B7280]">Notifications OFF</p>
          </div>
        </div>
        
        {/* Progress Bar */}
        <div className="bg-[hsl(var(--surface-elevated))] rounded-lg p-3 border border-[hsl(var(--border))]">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-[#6B7280]">Notification Rate</span>
            <span className="text-xs text-white">{notificationStats.enabled.toLocaleString()} / {notificationStats.total.toLocaleString()}</span>
          </div>
          <div className="h-3 bg-[hsl(var(--border))] rounded-full overflow-hidden flex">
            <div 
              className="h-full bg-gradient-to-r from-[#10B981] to-[#34D399] rounded-l-full transition-all"
              style={{ width: `${notificationStats.rate}%` }}
            />
            <div 
              className="h-full bg-[#374151]"
              style={{ width: `${100 - parseFloat(notificationStats.rate)}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationStatus;
